import {Component, Input, ViewChild} from '@angular/core';
import {SchoolDataInfoDto} from '../../../../../models/student-ticket/list-view/SchoolDataInfoDto';
import {WizardStepComponent} from '../../wizard-step-component.interface';
import {SchoolDetailsFormComponent} from '../../../../../shared/school-details-form/school-details-form.component';

@Component({
  selector: 'app-school-step',
  standalone: true,
  imports: [SchoolDetailsFormComponent],
  templateUrl: './school-step.component.html',
})
export class SchoolStepComponent implements WizardStepComponent {

  @Input() initialData: SchoolDataInfoDto | null;

  @ViewChild(SchoolDetailsFormComponent) private schoolForm: SchoolDetailsFormComponent;

  isValid(): boolean {
    return this.schoolForm.isValid();
  }

  getValue(): SchoolDataInfoDto {
    return this.schoolForm.getFormValue();
  }
}
